import type { PropsWithChildren } from 'react'
import type { SystemProps } from '@xstyled/styled-components'
import { x } from '@xstyled/styled-components'
import { getDirectionForLanguage } from './directionForLanguage'

type Size = 'sm' | 'md' | 'lg'

const sizes: Record<Size, SystemProps> = {
  sm: {
    text: 'sm',
    borderRadius: 'md',
    p: 2
  },
  md: {
    text: 'md',
    borderRadius: 'lg',
    p: 3
  },
  lg: {
    text: 'lg',
    borderRadius: 'xl',
    p: 3
  }
}

type BackgroundVariant = 'hover' | 'always' | 'none'

const backgroundVariants: Record<BackgroundVariant, SystemProps> = {
  hover: {
    bg: {
      _: 'transparent',
      hover: 'grey.l4'
    }
  },
  always: {
    bg: 'grey.l4'
  },
  none: {
    bg: 'transparent'
  }
}

export type TranscriptionPreviewRootProps = {
  testId?: string
  rows?: number
  language: string
  background?: 'hover' | 'always' | 'none'
  size?: Size
  fullHeight?: boolean
  dynamicHeight?: boolean
  h?: SystemProps['h']
}

export const TranscriptionPreviewRoot = (
  props: PropsWithChildren<TranscriptionPreviewRootProps>
): JSX.Element => {
  const directionForLanguage = getDirectionForLanguage(props.language)
  const maxHeight = props.dynamicHeight
    ? `calc((${props.rows} * 1.5rem) + 1rem)`
    : undefined
  const height = !props.dynamicHeight
    ? !props.fullHeight
      ? props.h
      : 'full'
    : 'full'

  return (
    <x.span
      data-testid={props.testId}
      display='block'
      overflow='hidden'
      overflowY='auto'
      boxSizing='border-box'
      whiteSpace='normal'
      h={height}
      maxHeight={maxHeight}
      dir={directionForLanguage.direction}
      textAlign={directionForLanguage.alignment}
      fontWeight={400}
      color='grey.d2'
      {...sizes[props.size ?? 'sm']}
      {...backgroundVariants[props.background ?? 'always']}
    >
      {props.children}
    </x.span>
  )
}
